var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE4MenLocker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.27 24.23l-12.81-8v-.56a1 1 0 01.7-.88A4.21 4.21 0 0055 7a4.18 4.18 0 00-4.21 4h3A1.2 1.2 0 0155 10a1.21 1.21 0 01.54 2.3 3.42 3.42 0 00-2.11 3.2v.72l-12.92 8a1.5 1.5 0 00.81 2.78h27.15a1.49 1.49 0 001.44-1.08 1.51 1.51 0 00-.64-1.69zM46.56 24l8.34-5.2 8.34 5.2H46.56zM34 24v16.49a2 2 0 11-4-.11V24a1 1 0 00-1-1h-2v44.32a2 2 0 11-4-.1V48h-3v19.32a2 2 0 11-4-.1V23h-2a1 1 0 00-1 1v16.4a2 2 0 11-4 .09V24a5 5 0 015-5h15a5 5 0 015 5zm-16.35-8.9a5 5 0 117.806-6.251 5 5 0 01-7.806 6.25z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E4_Men_locker.54cba93e.svg";
export { SvgE4MenLocker as ReactComponent };